import { render, staticRenderFns } from "./withdrawal-detail.vue?vue&type=template&id=69715363&scoped=true&"
import script from "./withdrawal-detail.vue?vue&type=script&lang=js&"
export * from "./withdrawal-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-detail.vue?vue&type=style&index=0&id=69715363&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69715363",
  null
  
)

export default component.exports